module.exports = __webpack_public_path__ + "img/asbjornsenmoe_06.e47610a6.jpg";